// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import { useField } from "formik";

import { Checkbox } from "components/form/elements";
import { getFieldTestId } from "utils/formik";

import { createMixedValidator } from ".";
import { FieldProps } from "./propTypes";

export const CheckboxField = (props) => {
  const { name, validate, dataTestId } = props;

  const [field, meta] = useField({
    ...props,
    type: "checkbox",
    validate: createMixedValidator(props.name, props.required, validate),
  });

  return (
    <Checkbox
      {...field}
      {...meta}
      {...props}
      dataTestId={dataTestId || getFieldTestId(name)}
    />
  );
};

CheckboxField.propTypes = FieldProps;
